import {v1 as uuidv1} from 'uuid';

export default {
    state: {
        userDecks: [],
        activeDeckID: null,
        unsavedActiveDeckChanges: false,
        addToDeckSnackbar: false,
    },
    getters: {
        getUserDecks: state => {
            return state.userDecks;
        },
        getActiveDeckID: state => {
            return state.activeDeckID;
        },
        getActiveDeck: (state) => {
            if (state.activeDeckID) {
                return state.userDecks.find(deck => deck.id === state.activeDeckID);
            } else {
                return null;
            }
        },
        getActiveDeckCardData: (state, getters) => {
            if (getters.getActiveDeck) {
                let activeDeckCopy = JSON.parse(JSON.stringify(getters.getActiveDeck));
                let cardData = [];
                activeDeckCopy.cards.forEach(deckEntry => {
                    deckEntry["cardData"] = getters.getCardById(deckEntry.id);
                    cardData.push(deckEntry);
                });
                return cardData;
            } else {
                return null;
            }
        },
        getUserDeckNames: state => {
            if (state.userDecks.length > 0) {
                let returnList = [];
                state.userDecks.forEach(deck => {
                    returnList.push(deck.name);
                });
                return returnList;
            } else {
                return [];
            }
        },
        getUnsavedActiveDeckChanges: state => {
            return state.unsavedActiveDeckChanges;
        },
        getAddToDeckSnackbar: state => {
            return state.addToDeckSnackbar;
        },
    },
    mutations: {
        setUserDecks(state, payload) {
            state.userDecks = payload;
        },
        setActiveDeckID(state, payload) {
            state.activeDeckID = payload;
        },
        clearActiveDeck(state) {
            state.activeDeck = null;
        },
        setUnsavedActiveDeckChanges(state, payload) {
            state.unsavedActiveDeckChanges = payload;
        },
        setAddToDeckSnackbar(state, payload) {
            state.addToDeckSnackbar = payload;
        },
    },
    actions: {
        addCardToActiveDeck({getters}, payload) {
            const deck = getters.getActiveDeck.cards;
            let addedCard = false;
            // check if any cards with this ID are already in the deck
            deck.forEach(deckEntry => {
                if (deckEntry.id === payload.id) {
                    deckEntry.quantity++;
                    addedCard = true;
                }
            });
            if (!addedCard) {
                deck.push({quantity: 1, subset: payload.subset, id: payload.id});
            }
        },
        removeCardFromActiveDeck({getters}, payload) {
            const deck = getters.getActiveDeck.cards;
            deck.forEach((deckEntry, index) => {
                if (deckEntry.id === payload.id && deckEntry.subset === payload.subset) {
                    if (deckEntry.quantity > 1) {
                        deckEntry.quantity--;
                    } else {
                        deck.splice(index, 1);
                    }
                }
            });
        },
        // payload is a deck object
        addUserDeck({commit, getters}, payload) {
            let decks = getters.getUserDecks;
            decks.push(payload);
            commit("setUserDecks", decks);
            commit("setActiveDeckID", payload.id);
        },
        // payload is a deck object
        deleteUserDeck({commit, getters}, payload) {
            let decks = getters.getUserDecks;
            decks = decks.filter(deck => deck !== payload);
            commit("setUserDecks", decks);
            commit("clearActiveDeck");
        },
        // payload is a deck name
        createNewDeck({getters, dispatch}, payload) {
            let deckID = uuidv1();
            dispatch("addUserDeck", {
                id: deckID,
                name: payload.deckName,
                userid: getters.user.uid,
                cards: [],
            });
        },
    }
};